/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G1_DInputs */

const en_mk_sec_pg_g1_d = /** @type {(inputs: Mk_Sec_Pg_G1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are 19 tools an agent can use. You choose which ones each agent may touch — except the tool that closes a run, which is always on so every piece of work ends on the record. The rest simply do not exist for that agent.`)
};

const id_mk_sec_pg_g1_d = /** @type {(inputs: Mk_Sec_Pg_G1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada 19 alat yang bisa dipakai agen. Anda menentukan mana yang boleh untuk tiap agen — kecuali alat penutup run, yang selalu aktif supaya setiap pekerjaan punya akhir yang tercatat. Sisanya tidak tersedia sama sekali bagi agen itu.`)
};

/**
* | output |
* | --- |
* | "There are 19 tools an agent can use. You choose which ones each agent may touch — except the tool that closes a run, which is always on so every piece of wor..." |
*
* @param {Mk_Sec_Pg_G1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g1_d = /** @type {((inputs?: Mk_Sec_Pg_G1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g1_d(inputs)
	return en_mk_sec_pg_g1_d(inputs)
});